(function($) {
	'use strict';

	$.widget('msv.datalist', {
		vars: {},
		options: {
			limit: 4,
			wrapper: '.form-datalist',
			textField: '.form-item-text',
			optionsList: '.form-datalist__options',
			pointer: '.form-datalist__pointer'
		},

		_create: function() {
			var self = this;
			this.options.wrapper = this.element;
			this.options.textField = this.options.wrapper.find(this.options.textField);
			this.options.optionsList = this.options.wrapper.find(this.options.optionsList);
			this.options.pointer = this.options.wrapper.find(this.options.pointer);
			this.buttonViewAll = this.element.parent().parent().find('.js-btn-view-all');
			this.vars.enableScroll = self.element.data('enable-scroll');

			if (self.vars.enableScroll)
				this.options.optionsList.css({ 'overflow-y': 'auto', 'max-height': '300px' });

			this.options.textField.click(function(e) {
				var result = self.filterBy($(e.target).val());
				self.populateLocations(result);
				self.open();
			});
			this.options.textField.keyup(function(e) {
				//console.log('text keyup');
				var result = self.filterBy(self.options.textField.val());
				self.populateLocations(result);
				self.open();
			});
			this.options.textField.blur(function(e) {
				setTimeout(function() {
					self.close();
				}, 200);
			});
			this.options.pointer.mouseup(function() {
				if (self.options.wrapper.hasClass("opened")) {
					self.close();
				}
				else {
					var result = self.filterBy(self.options.textField.val());
					self.populateLocations(result);
					self.open();
				}
			});
			$(window).resize(function() {
				self.redraw();
			});
		},

		open: function() {
			this.options.wrapper.addClass("opened");
			this.redraw();
			this.options.textField.focus();
		},

		close: function() {
			this.options.textField.val('');
			this.options.wrapper.removeClass("opened");
		},

		redraw: function() {
			//console.log('redraw');
			this.options.optionsList.width(this.options.textField.width() + 2);
		},

		filterBy: function(inserted) {
			//console.log("filterby: ", inserted);
			var temp = [];
			if (inserted) {
				$.each(BEC.locations, function(index, value) {
					if (BEC.locations[index].name.toLowerCase().indexOf(inserted.toLowerCase()) > -1) {
						temp.push(BEC.locations[index]);
					}
				});
			}
			else {
				temp = BEC.locations;
			}
			return temp;
		},

		populateLocations: function(list) {
			var self = this;
			this.options.optionsList.empty();
			if (!list || list.length === 0) {
				this.options.optionsList.append("<span>No results.</span>");
			}
			else {
				$.each(list, function(index, value) {
					var option = $("<span><a href='javascript:void(0)' data-id='" + value.id + "'>" + value.name + "</a></span>");
					option.click(self, function(e) {
						var mapElementId = $(e.data.element).data('bind-map');
						if (mapElementId)
							$(mapElementId).googlemap('focusMarkerById', value.id);
					});
					self.options.optionsList.append(option);
					if (!self.vars.enableScroll && index >= self.options.limit) {
						return false;
					}
				});

				if (!self.vars.enableScroll && list.length > this.options.limit) {
					self.options.optionsList.append("<span class='milli'>Total of " + list.length + " results found.</span>");
				}
			}
		}

	});

})(jQuery);